export default __webpack_public_path__ + "static/media/home_imagen_financar.3408d00a.png";